import * as dispatchOrders from './dispatchOrders';
import * as dispatchOrderForm from './dispatchOrderForm';

const reducers = {
  ...dispatchOrders,
  ...dispatchOrderForm,
};

export default reducers;
